/**
 * @generated SignedSource<<8cba641b5107a0a9e2f5ff57ce75c87b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoCountAnalytics_TodoStats$data = {
  readonly created: ReadonlyArray<{
    readonly count: number;
    readonly date: string;
  }>;
  readonly resolved: ReadonlyArray<{
    readonly count: number;
    readonly date: string;
  }>;
  readonly " $fragmentType": "TodoCountAnalytics_TodoStats";
};
export type TodoCountAnalytics_TodoStats$key = {
  readonly " $data"?: TodoCountAnalytics_TodoStats$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoCountAnalytics_TodoStats">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "date",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoCountAnalytics_TodoStats",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoPerDateStat",
      "kind": "LinkedField",
      "name": "created",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssuePerDateStat",
      "kind": "LinkedField",
      "name": "resolved",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "TodoStats",
  "abstractKey": null
};
})();

(node as any).hash = "c492e6e0298f2068d9b1bffcf18a8d98";

export default node;
